import React from 'react';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from './store';
import { GlobalErrorBoundary } from './Components/errorBoundary';

//import Scss
import './assets/scss/themes.scss';

//import css for error boundary
import './index.css';

//import Route
import Route from './Routes';

// LOV System
import { useAuthWithLov } from 'features/auth/hooks/useAuthWithLov';



function App() {
  // This hook automatically triggers LOV loading when user is authenticated
  useAuthWithLov();

  return (
    <PersistGate loading={null} persistor={persistor}>
      <GlobalErrorBoundary>
        <Route />
      </GlobalErrorBoundary>
    </PersistGate>
  );
}

export default App;
